import { receiptStates } from '@/modules/base/util/constants'
import Decimal from 'decimal.js'

type CalculateReceiptPrices = {
  state: string,
  outstandingAmount: number,
  priceTotal: number,
  priceNet: number,
}

const { OPEN, TO_ANALYZE, DRAFT } = receiptStates
const statesToRecalculate = [OPEN, TO_ANALYZE, DRAFT]

export const calculateReceiptPrices = (positions, data: CalculateReceiptPrices): { priceTotal: number, priceNet: number, outstandingAmount: number } => {
  const { state, outstandingAmount, priceTotal, priceNet } = data
  const result = positions.reduce((calc, position) => ({
    priceTotal: calc.priceTotal.plus(position.totalGross),
    priceNet: calc.priceNet.plus(position.totalNet),
  }), {
    priceTotal: new Decimal(0),
    priceNet: new Decimal(0),
  })

  const calculatedPriceTotal = !statesToRecalculate.includes(state)
    ? priceTotal
    : result.priceTotal.toDP(2).toNumber()

  const calculatedPriceNet = !statesToRecalculate.includes(state)
    ? priceNet
    : result.priceNet.toDP(2).toNumber()

  return {
    priceTotal: calculatedPriceTotal,
    priceNet: calculatedPriceNet,
    outstandingAmount: [receiptStates.OPEN, receiptStates.DRAFT].includes(state) ? calculatedPriceTotal : outstandingAmount,
  }
}
